<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link :to="{ name: 'Home' }">{{ $t("nav.home") }}</router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          {{ $t("nav.export") }}
        </li>
      </ol>
    </nav>
    <b-container fluid>
      <h2 class="mb-4">{{ $t("label.export_docs") }}</h2>
      <b-input-group :prepend="$t('label.statsbyweek')" class="mb-4">
        <b-form-input
          id="filename_stats_week"
          v-model="fnameStatWeek"
          :placeholder="$t('placeholder.filename')"
          type="text"
        ></b-form-input>
        <b-input-group-append>
          <b-btn variant="success" @click="getStatsWeek()"
            ><template v-if="IsDownloadStatWeek">
              <b-spinner small type="grow"></b-spinner>
              {{ $t("btn.loading") }}
            </template>
            <template v-else>
              <font-awesome-icon :icon="['fas', 'download']" />
              &nbsp;{{ $t("btn.download") }}
            </template>
          </b-btn>
        </b-input-group-append>
      </b-input-group>
      <b-input-group :prepend="$t('label.deviceversion')" class="mb-4">
        <b-form-input
          id="filename_app_device"
          v-model="fnameAppDevice"
          :placeholder="$t('placeholder.filename')"
          type="text"
        ></b-form-input>
        <b-input-group-append>
          <b-btn variant="success" @click="getAppDeviceVersion()"
            ><template v-if="IsDownloadAppDevice">
              <b-spinner small type="grow"></b-spinner>
              {{ $t("btn.loading") }}
            </template>
            <template v-else>
              <font-awesome-icon :icon="['fas', 'download']" />
              &nbsp;{{ $t("btn.download") }}
            </template>
          </b-btn>
        </b-input-group-append>
      </b-input-group>
      <b-input-group :prepend="$t('label.suiviclient')" class="mb-4">
        <b-form-datepicker
          placeholder="Choisir la date de début"
          :state="suivi.debut.state"
          v-model="suivi.debut.date"
          @context="onDebContext"
        ></b-form-datepicker>
        <b-form-datepicker
          placeholder="Choisir la date de fin"
          :state="suivi.fin.state"
          v-model="suivi.fin.date"
          @context="onFinContext"
        ></b-form-datepicker>
        <b-form-input
          id="filename_suivi_client"
          v-model="suivi.filename"
          :placeholder="$t('placeholder.filename')"
          type="text"
        ></b-form-input>
        <b-input-group-append>
          <b-btn
            :disabled="!(suivi.fin.state && suivi.debut.state)"
            :variant="
              !(suivi.fin.state && suivi.debut.state) ? 'secondary' : 'success'
            "
            @click="getSuiviClient()"
          >
            <template v-if="IsDownloadSuivi">
              <b-spinner small type="grow"></b-spinner>
              {{ $t("btn.loading") }}
            </template>
            <template v-else>
              <font-awesome-icon :icon="['fas', 'download']" />
              &nbsp;{{ $t("btn.download") }}
            </template>
          </b-btn>
        </b-input-group-append>
      </b-input-group>
    </b-container>
  </div>
</template>

<script>
import {
  expAllStatByWeek,
  expAppDeviceVersion,
  expSuiviClient,
} from "../services/export";
export default {
  name: "Export",
  data() {
    return {
      IsDownloadStatWeek: false,
      IsDownloadAppDevice: false,
      IsDownloadSuivi: false,
      fnameStatWeek: this.$t("file.statsWeek"),
      fnameAppDevice: this.$t("file.appDevices"),
      dFinSuiviClient: null,
      dDebutSuiviClient: null,
      suivi: {
        debut: {
          state: false,
          date: null,
        },
        fin: {
          state: false,
          date: null,
        },
        filename: this.$t("file.suiviClients"),
      },
    };
  },
  methods: {
    async getStatsWeek() {
      this.IsDownloadStatWeek = true;
      await expAllStatByWeek(this.fnameStatWeek).then(
        () => (this.IsDownloadStatWeek = false)
      );
    },
    async getAppDeviceVersion() {
      this.IsDownloadAppDevice = true;
      await expAppDeviceVersion(this.fnameAppDevice).then(
        () => (this.IsDownloadAppDevice = false)
      );
    },
    onDebContext(ctx) {
      this.suivi.debut.state = ctx.selectedDate !== null;
    },
    async getSuiviClient() {
      this.IsDownloadSuivi = true;
      await expSuiviClient(
        this.suivi.debut.date,
        this.suivi.fin.date,
        this.suivi.filename
      ).then(() => (this.IsDownloadSuivi = false));
    },
    onFinContext(ctx) {
      this.suivi.fin.state = ctx.selectedDate !== null;
    },
  },
};
</script>

<style scoped>
</style>
